<template lang="pug">
input.fieldset__input(
  :class="classes"
  :name="name"
  :id="name"
  :type="type"
  :placeholder="placeholder"
  v-model="internalValue"
  @change="$emit('change', internalValue)"
)
</template>

<script>
export default {
  name: 'fieldset__input',
  props: {
    wide: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: null,
    },
    error: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      internalValue: null,
    }
  },
  watch: {
    value(val, old) {
      if (val === old) return
      this.internalValue = val
    },
    internalValue(val, old) {
      if (val === old || old === null) return
      this.$emit('input', val)
    },
  },
  computed: {
    classes() {
      return {
        '--wide': this.wide,
        '--empty': !this.value,
        '--error': !!this.error,
      }
    },
  },
  mounted() {
    this.internalValue = this.value
  },
}
</script>